import TextInput from "@client/controls/Inputs/TextInput/component";
import { copyToClipboard } from "@common/lib/clipboard";
import toasts from "@common/lib/toast";
import classNames from "classnames";
import { identity } from "lodash";
import React from "react";

import { useI18n } from "@common/hooks/i18n";
import "./styles.less";

export interface MapProps {
  text: string;
  hideInput?: boolean;
  children?: any;
}

const CopyToClipboard = (props: MapProps) => {
  const i18n = useI18n();

  const onCopy = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      copyToClipboard(props.text);

      toasts.info(i18n.copiedToClipboard);
    },
    [i18n, props.text]
  );

  return (
    <div className={classNames("wsc_copy_to_clipboard", { no_input: !!props.hideInput })} onClick={onCopy}>
      <TextInput value={props.text} isReadonly onChange={identity} />

      {props.children}
    </div>
  );
};
export default CopyToClipboard;
